
import {default as allOfficeRegions} from './dictionaries/allOfficeRegions.js';
import {default as feedbackModalData}
	from './dictionaries/feedbackModalData.js';


export {
	allOfficeRegions,
	feedbackModalData,
};